/**
 * Append a list item indicating there are more hidden items.
 *
 * @param dropdownUl - The dropdown unordered list element to render into
 * @param moreNumber - The number of additional items to display
 * @returns The created `HTMLLIElement` appended to `dropdownUl`
 */
export const renderMoreItems = (dropdownUl: HTMLUListElement, moreNumber: number) => {
  const atSpan = document.createElement("li");
  atSpan.classList.add("aiev3-more-items");
  atSpan.textContent = `...${moreNumber} more`;
  dropdownUl.appendChild(atSpan);
  return atSpan;
};
